import { render, staticRenderFns } from "./iconImg.vue?vue&type=template&id=04f5cb9a"
import script from "./iconImg.vue?vue&type=script&lang=js"
export * from "./iconImg.vue?vue&type=script&lang=js"
import style0 from "./iconImg.vue?vue&type=style&index=0&id=04f5cb9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports